






















































import { Vue, Component } from 'vue-property-decorator'
import { mapActions, mapGetters } from 'vuex'
import navigate from '../libs/navigate'
import i18n from './../i18n'

@Component({
  methods: {
    ...mapActions('Accounts', ['signUp']),
    navigate
  }
})
export default class SignUp extends Vue {
  signUp!: (credentials: {}) => void // from the mapActions above
  email = ''
  password = ''
  passwordConfirm = ''
  loading= false

  valid=false

  data () {
    return {

      passwordRules: [
        (v: string) => (v && v.length >= 8) || i18n.t('signUp.passwordRules'),
        (v: string) => /(?=.*[A-Z])/.test(v) || i18n.t('signUp.passwordRules1'),
        (v: string) => /(?=.*\d)/.test(v) || i18n.t('signUp.passwordRules2'),
        (v: string) => /(?=.*[a-z])/.test(v) || i18n.t('signUp.passwordRules3')
      ],
      confirmPasswordRules: [
        (value: any) => !!value || 'Type confirm password',
        (value: string) =>
          value === this.password || 'The password confirmation does not match.'
      ]
    }
  }

  async submitSignUp () {
    if ((this.$refs.form as Vue & { validate: () => boolean }).validate()) {
      this.loading = true
      const { email, password, passwordConfirm } = this
      await new Promise(resolve => setTimeout(resolve, 1000))
      await this.signUp({ email, password, passwordConfirm })
      this.loading = false
    }
  }
}

